import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import "whatwg-fetch";

const abortableFetch = ('signal' in new Request('')) ? window.fetch : fetch;

export default class Backend {
  static defaultOptions() {
    return {
      credentials: 'include',
      headers: {
        'X-CSRF-Token': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content"),
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
  }

  static request(url, options, method) {
    return fetch(url, {
      ...Backend.defaultOptions(),
      ...options,
      method: method
    }).then(response => response.json());
  }

  static abortableRequest(url, options, method) {
    const controller = new AbortController();
    return [
      abortableFetch(url, {
        ...Backend.defaultOptions(),
        ...options,
        signal: controller.signal,
        method: method
      }).then(response => response.json(), reason => reason),
      controller.abort.bind(controller)
    ];
  }

  static post(url, options = {}) {
    return Backend.request(url, options, 'POST');
  }

  static requestJson(url, options = {}, kind = 'POST') {
    return Backend.request(
      url,
      {
        ...options,
        ...{
          headers: {
            ...Backend.defaultOptions().headers,
            'Content-Type': 'application/json'
          }
        }
      },
      kind
    );
  }

  static postJson(url, options = {}) {
    return Backend.requestJson(url, options, 'POST');
  }

  static patch(url, options = {}) {
    return Backend.request(url, options, 'PATCH');
  }

  static put(url, options = {}) {
    return Backend.request(url, options, 'PUT');
  }

  static delete(url, options = {}) {
    return Backend.request(url, options, 'DELETE');
  }

  static get(url, options = {}) {
    return Backend.request(url, options, 'GET');
  }

  static load(url, options = {}) {
    return fetch(url, {
      ...Backend.defaultOptions(),
      ...options,
      method: 'GET'
    }).then(response => response.text());
  }

  static abortableGet(url, options = {}) {
    return Backend.abortableRequest(url, options, 'GET');
  }

  static abortablePost(url, options = {}) {
    return Backend.abortableRequest(url, options, 'POST')
  }

  static abortablePostJson(url, options = {}) {
    return Backend.abortableRequest(url, {
      ...options,
      ...{
        headers: {
          ...Backend.defaultOptions().headers,
          'Content-Type': 'application/json'
        }
      }
    }, 'POST')
  }

  static abortablePatchJson(url, options = {}) {
    return Backend.abortableRequest(url, {
      ...options,
      ...{
        headers: {
          ...Backend.defaultOptions().headers,
          'Content-Type': 'application/json'
        }
      }
    }, 'PATCH')
  }
}
